import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../../notes/icon/icon.module';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { PreferenceGridComponent } from './preferences-grid.component';

@NgModule({
  declarations: [PreferenceGridComponent],
  imports: [CommonModule, IconModule, MessageBannerModule],
  exports: [PreferenceGridComponent],
})
export class PreferencesGridModule {}
